module.exports = __webpack_public_path__ + "assets/95feae7d15e1933015c4a1970d52f813.jpg";